const experience = [
    {
        id: 1,
        title: "Platform Engineering Intern",
        company: "Invisibl Cloud Solutions Pvt. Ltd.",
        location: "Chennai, India",
        startDate: "July 2024",
        endDate: "Dec 2024",
        description: [
            "Engineered a reliable, hallucination-free RAG chatbot enabling LLM interoperability (Gemini, Anthropic, Azure OpenAI) across AWS, GCP, and OpenSearch data. Developed FastAPI APIs, Streamlit UIs, and AI agents. Contributed to a multimodal LLM algorithm for accurate, non-hallucinatory image descriptions."
        ]
    },
    {
        id: 2,
        title: "Hackathon Final Round Participant - [Hackz'24]",
        company: "Computer Science and Engineering Association (CSEA), CEG",
        location: "College of Engineering Guindy",
        startDate: "Nov 2024", // Date of the hackathon
        endDate: "Nov 2024",
        description: [
            "Collaborated with a 4-person team to develop a  Infinsa App, AI-powered mobile app for digital banking and financial planning within 24 hours. Engineered the Frontend User Interface (UI) using FlutterFlow.",
            "Technologies used: FlutterFlow, Python, Haystack, PostgreSQL, Gemini Flash"
        ]
    },
];

export default experience;